export default __webpack_public_path__ + "static/N0311-535cd29f0c07c9043d1bc940729ad270.png";